import { Button, type ButtonProps } from "@/design-system/components/ui/button"; // Tu botón base de Shadcn
import { LoaderCircle } from "lucide-react";
import { cn } from "@/design-system/utils";
import { FORM_STYLES } from "@/design-system/lib/form-styles"; // Tu archivo de estilos

interface LoadingButtonProps extends ButtonProps {
  isLoading?: boolean;
  loadingLabel?: string; // Por si algún botón específico requiere texto mientras carga
}

export function LoadingButton({
  children,
  isLoading = false,
  loadingLabel,
  className,
  disabled,
  ...props
}: LoadingButtonProps) {
  return (
    <Button
      disabled={disabled || isLoading}
      className={cn(
        "transition-all active:scale-[0.98]", // Efecto elástico sutil al pulsar en cualquier botón
        className,
      )}
      {...props}
    >
      {isLoading ? (
        <div className="flex items-center justify-center gap-2">
          <LoaderCircle className={FORM_STYLES.buttonSpinner} />
          {loadingLabel && (
            <span className="animate-pulse">
              {loadingLabel}
            </span>
          )}
        </div>
      ) : (
        children
      )}
    </Button>
  );
}
